import { DeprecatedChevronUpIcon, DeprecatedChevronDownIcon } from '@arnold/common';
import { FC } from 'react';
import styled from '@emotion/styled/macro';
import { Button } from 'react-bootstrap';

const LinkButton = styled(Button)`
  :focus,
  :hover {
    border: none !important;
    box-shadow: unset;
  }
`;

type ExpandLinkProps = {
  text: string;
  expanded: boolean;
  click: any;
  dataIcom?: string;
};

export const ExpandLink: FC<ExpandLinkProps> = ({ text, expanded, click, dataIcom }) => (
  <div>
    <LinkButton data-icom={dataIcom} variant={'link'} className="no-btn font-size-s mr-5" onClick={click}>
      {text}
    </LinkButton>
    {expanded ? <DeprecatedChevronUpIcon /> : <DeprecatedChevronDownIcon />}
  </div>
);
